var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPinTwo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5703_38669)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5703_38669",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 0H0V24H24V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5703_38669)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_5703_38669)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.325 5.58567C15.1009 5.36161 14.8268 5.194 14.5252 5.09667C14.2236 4.99934 13.9032 4.97506 13.5904 5.02585C13.2776 5.07663 12.9813 5.20102 12.726 5.38876C12.4707 5.5765 12.2637 5.82222 12.122 6.10567L10.392 9.56467C10.2277 9.89282 9.94874 10.1493 9.608 10.2857L6.018 11.7217C5.86433 11.7832 5.72833 11.8819 5.6222 12.0089C5.51607 12.1359 5.44314 12.2873 5.40993 12.4495C5.37673 12.6116 5.38429 12.7795 5.43195 12.938C5.47961 13.0965 5.56587 13.2407 5.683 13.3577L8.293 15.9687L5 19.2607V19.9687H5.707L9 16.6747L11.61 19.2847C11.727 19.4018 11.8712 19.4881 12.0297 19.5357C12.1882 19.5834 12.3561 19.5909 12.5182 19.5577C12.6804 19.5245 12.8318 19.4516 12.9588 19.3455C13.0858 19.2393 13.1845 19.1033 13.246 18.9497L14.682 15.3597C14.8186 15.0188 15.0755 14.7398 15.404 14.5757L18.862 12.8457C19.1455 12.704 19.3912 12.4969 19.5789 12.2416C19.7667 11.9863 19.891 11.6901 19.9418 11.3773C19.9926 11.0645 19.9683 10.7441 19.871 10.4425C19.7737 10.1409 19.6061 9.86677 19.382 9.64267L15.325 5.58567Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.7356 9.28912L15.6785 5.23209C15.3984 4.95201 15.0557 4.7425 14.6788 4.62084C14.3018 4.49917 13.9013 4.46883 13.5103 4.53231C13.1193 4.59579 12.749 4.75127 12.4298 4.98595C12.1107 5.22061 11.8519 5.52773 11.6748 5.88201L9.94493 9.34078C9.83536 9.55944 9.64934 9.73059 9.42226 9.82145L5.8323 11.2574C5.60179 11.3496 5.39769 11.4978 5.2385 11.6883C5.07931 11.8788 4.9699 12.1059 4.9201 12.3492C4.87029 12.5924 4.88164 12.8442 4.95313 13.082C5.02459 13.3196 5.15392 13.5359 5.32951 13.7113L7.58591 15.9685L4.6465 18.9071L4.5 19.0535V19.2607V19.9687V20.4687H5H5.707H5.91415L6.06061 20.3222L9.00005 17.3818L11.2562 19.638C11.4316 19.8137 11.6479 19.9431 11.8857 20.0145C12.1235 20.086 12.3753 20.0974 12.6185 20.0476C12.8618 19.9978 13.0888 19.8884 13.2794 19.7292C13.4699 19.57 13.6179 19.3659 13.7102 19.1354L15.1462 15.5454C15.2373 15.3182 15.4087 15.1321 15.6277 15.0228L19.0857 13.2928C19.44 13.1157 19.7471 12.8569 19.9817 12.5378C20.2164 12.2187 20.3719 11.8484 20.4354 11.4574C20.4988 11.0664 20.4685 10.6659 20.3468 10.2889C20.2252 9.91194 20.0157 9.56924 19.7356 9.28912Z",
    stroke: "#242129",
    strokeOpacity: 0.27
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_5703_38669",
    x: 0,
    y: 0,
    width: 24.9678,
    height: 24.9688,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.14902 0 0 0 0 0.164706 0 0 0 0 0.243137 0 0 0 0.29 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5703_38669"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5703_38669",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5703_38669"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinTwo);
export default __webpack_public_path__ + "static/media/pin-two.8351a9aa47f6141dba8a98dca58570ed.svg";
export { ForwardRef as ReactComponent };